import { getPage } from "../shared/global";
import reporter from "./reporter";

// https://doc.huanleguang.com/pages/viewpage.action?pageId=217664965
/**
 * @param {{
 *   upload_source: string,
 *   upload_num: number
 *   upload_status: '全部成功'|'部分成功'|'全部失败' | '部分失败'
 *   upload_type: 'web端'
 * }} data
 */
export function uploadTracker(data) {
  const page = getPage();
  const { page_nm, sub_page_nm } = page;

  reporter({
    ...data,
    ...page,
    event_id: 39043,
    event_name: "upload_complete",
    upload_source:
      `${page_nm}_${sub_page_nm || ""}` +
      (data.upload_source ? `_${data.upload_source}` : ""),
  });
}
